import { LEAD_STATUS, USER_TYPE } from 'home/view/upgrade-order/constants';

const trackEvent = (data) => {
  try {
    if (!data) {
      const errorMsg = `No data found for click stream analytics`;
      throw new Error(errorMsg);
    }

    if (window && window.ClickStream && typeof window.ClickStream !== 'undefined') {
      window.ClickStream.trackEvent(data);
    }
  } catch (e) {
    console.error(e);
  }
};

const getBaseDataSet = (leadData, userType) => {
  const customerBaseStr = `b2b|data|landing page|circuits|change order`;
  const kamBaseStr = `b2b|dedicated internet|kam view|customer request`;

  let dataSet = {
    prop0: `b2b|data`,
    prop13: `DATA`
  };

  const isKam = userType === USER_TYPE.KAM;

  const loggedInUserDetail =
    leadData &&
    leadData.initiators &&
    Array.isArray(leadData.initiators) &&
    leadData.initiators.length > 0 &&
    leadData.initiators.find((item) => (isKam ? item.type === 'KAM' : item.type === 'JOURNEY_INITIATOR'));

  const phoneNumber = (loggedInUserDetail && loggedInUserDetail.phoneNumber) || '';

  const emailId = (loggedInUserDetail && loggedInUserDetail.email) || '';

  const fullName = loggedInUserDetail && `${loggedInUserDetail.firstName || ''} ${loggedInUserDetail.lastName || ''}`;

  const companyName = leadData && leadData.customer && leadData.customer.name;

  const partyId = leadData && leadData.partyId;

  const channel = leadData && leadData.channel;

  const productName = (leadData && leadData.lineItems && Array.isArray(leadData.lineItems) && leadData.lineItems.length > 0 && leadData.lineItems[0].productName) || '';

  const leadId = (leadData && leadData.lineItems && Array.isArray(leadData.lineItems) && leadData.lineItems.length > 0 && leadData.lineItems[0].leadId) || '';

  const feasibilityStatus =
    (leadData &&
      leadData.lineItems &&
      Array.isArray(leadData.lineItems) &&
      leadData.lineItems.length > 0 &&
      leadData.lineItems[0].plan &&
      leadData.lineItems[0].plan.site &&
      Array.isArray(leadData.lineItems[0].plan.site) &&
      leadData.lineItems[0].plan.site.length > 0 &&
      leadData.lineItems[0].plan.site[0].feasibilityResponse &&
      leadData.lineItems[0].plan.site[0].feasibilityResponse.feasibilityStatus) ||
    '';

  const otc =
    (leadData &&
      leadData.lineItems &&
      Array.isArray(leadData.lineItems) &&
      leadData.lineItems.length > 0 &&
      leadData.lineItems[0].plan &&
      leadData.lineItems[0].plan.price &&
      leadData.lineItems[0].plan.price.oneTimeCharge) ||
    '';

  const arc =
    (leadData &&
      leadData.lineItems &&
      Array.isArray(leadData.lineItems) &&
      leadData.lineItems.length > 0 &&
      leadData.lineItems[0].plan &&
      leadData.lineItems[0].plan.price &&
      leadData.lineItems[0].plan.price.rental) ||
    '';

  const contractPeriod = (leadData && leadData.lineItems && Array.isArray(leadData.lineItems) && leadData.lineItems.length > 0 && leadData.lineItems[0].contractPeriod) || '';

  if (phoneNumber) {
    dataSet['prop14'] = phoneNumber;
  }

  if (emailId) {
    dataSet['prop15'] = emailId;
  }

  if (fullName) {
    dataSet['prop16'] = fullName;
  }

  if (companyName) {
    dataSet['prop35'] = companyName;
  }

  if (partyId) {
    dataSet['prop36'] = partyId;
  }

  if (channel) {
    dataSet['prop39'] = channel;
  }

  if (productName) {
    dataSet['prop40'] = productName;
  }

  if (leadId) {
    dataSet['prop43'] = leadId;
  }

  if (feasibilityStatus) {
    dataSet['prop29'] = feasibilityStatus;
  }

  if (otc) {
    dataSet['prop18'] = otc;
  }

  if (arc) {
    dataSet['prop23'] = arc;
  }

  if (contractPeriod) {
    dataSet['prop22'] = contractPeriod;
  }

  return {
    dataSet,
    isKam,
    customerBaseStr,
    kamBaseStr,
    leadStatus: leadData && leadData.leadStatus
  };
};

const fsPageOnLoad = (leadData, userType) => {
  console.log('on page load', '--> click-stream');

  const { dataSet, leadStatus, isKam, customerBaseStr, kamBaseStr } = getBaseDataSet(leadData, userType);

  const trackData = {
    ...dataSet
  };

  if (leadStatus === LEAD_STATUS.LEAD_IN_PROGRESS) {
    trackData['eVar0'] = isKam ? `${kamBaseStr}` : `${customerBaseStr}`;
  }

  if (leadStatus === LEAD_STATUS.FEASIBILITY_COMPLETED || leadStatus === LEAD_STATUS.FEASIBILITY_PENDING || leadStatus === LEAD_STATUS.LOCATION_NOT_FEASIBLE) {
    trackData['eVar0'] = isKam ? `${kamBaseStr}|feasibility` : `${customerBaseStr}|feasibility`;
  }

  if (leadStatus === LEAD_STATUS.REQUIRED_PRICE_NEGOTIATION) {
    trackData['eVar0'] = isKam ? `${kamBaseStr}|feasibility|choose plan |need assistance` : `${customerBaseStr}|feasibility|choose plan |need assistance`;
  }

  if (leadStatus === LEAD_STATUS.LEAD_SUBMITTED) {
    trackData['eVar0'] = isKam ? `${kamBaseStr}|feasibility|choose plan` : `${customerBaseStr}|feasibility|choose plan`;
  }

  if (leadStatus === LEAD_STATUS.KYC_IN_PROGRESS) {
    trackData['eVar0'] = isKam ? `${kamBaseStr}|feasibility|choose plan|booking summary` : `${customerBaseStr}|feasibility|choose plan|booking summary`;
  }

  if (leadStatus === LEAD_STATUS.KYC_SUBMITTED) {
    trackData['eVar0'] = isKam ? `${kamBaseStr}|feasibility|choose plan|booking summary|thank you` : `${customerBaseStr}|feasibility|choose plan|booking summary|thank you`;
  }

  trackEvent(trackData);
};

const fsGoBackOnClick = (leadData, userType) => {
  console.log('on go back button click', '--> click-stream');

  const { dataSet, leadStatus, isKam, customerBaseStr, kamBaseStr } = getBaseDataSet(leadData, userType);

  const trackData = {
    ...dataSet
  };

  if (leadStatus === LEAD_STATUS.LEAD_IN_PROGRESS) {
    trackData['eVar8'] = isKam ? `${kamBaseStr}` : `${customerBaseStr}`;
    trackData['eVar9'] = isKam ? `${kamBaseStr}|go back` : `${customerBaseStr}|go back`;
  }

  if (leadStatus === LEAD_STATUS.FEASIBILITY_COMPLETED || leadStatus === LEAD_STATUS.FEASIBILITY_PENDING || leadStatus === LEAD_STATUS.LOCATION_NOT_FEASIBLE) {
    trackData['eVar8'] = isKam ? `${kamBaseStr}|feasibility` : `${customerBaseStr}|feasibility`;
    trackData['eVar9'] = isKam ? `${kamBaseStr}|feasibility|go back` : `${customerBaseStr}|feasibility|go back`;
  }

  if (leadStatus === LEAD_STATUS.REQUIRED_PRICE_NEGOTIATION) {
    trackData['eVar8'] = isKam ? `${kamBaseStr}|feasibility|choose plan|need assistance` : `${customerBaseStr}|feasibility|choose plan|need assistance`;
    trackData['eVar9'] = isKam ? `${kamBaseStr}|feasibility|choose plan|need assistance|go back` : `${customerBaseStr}|feasibility|choose plan|need assistance|go back`;
  }

  if (leadStatus === LEAD_STATUS.LEAD_SUBMITTED) {
    trackData['eVar8'] = isKam ? `${kamBaseStr}|feasibility|choose plan` : `${customerBaseStr}|feasibility|choose plan`;
    trackData['eVar9'] = isKam ? `${kamBaseStr}|feasibility|choose plan|go back` : `${customerBaseStr}|feasibility|choose plan|go back`;
  }

  if (leadStatus === LEAD_STATUS.KYC_IN_PROGRESS) {
    trackData['eVar8'] = isKam ? `${kamBaseStr}|feasibility|choose plan|booking summary` : `${customerBaseStr}|feasibility|choose plan|booking summary`;
    trackData['eVar9'] = isKam ? `${kamBaseStr}|feasibility|choose plan|booking summary|go back` : `${customerBaseStr}|feasibility|choose plan|booking summary|go back`;
  }

  trackEvent(trackData);
};

const fsCancelOrderOnClick = (leadData, userType) => {
  console.log('on cancel order button click', '--> click-stream');

  const { dataSet, leadStatus, isKam, customerBaseStr, kamBaseStr } = getBaseDataSet(leadData, userType);

  const trackData = {
    ...dataSet
  };

  if (leadStatus === LEAD_STATUS.LEAD_IN_PROGRESS) {
    trackData['eVar8'] = isKam ? `${kamBaseStr}` : `${customerBaseStr}`;
    trackData['eVar9'] = isKam ? `${kamBaseStr}|cancel` : `${customerBaseStr}|cancel`;
  }

  if (leadStatus === LEAD_STATUS.FEASIBILITY_COMPLETED) {
    trackData['eVar8'] = isKam ? `${kamBaseStr}|feasibility` : `${customerBaseStr}|feasibility`;
    trackData['eVar9'] = isKam ? `${kamBaseStr}|feasibility|cancel` : `${customerBaseStr}|feasibility|cancel`;
  }

  if (leadStatus === LEAD_STATUS.REQUIRED_PRICE_NEGOTIATION) {
    trackData['eVar8'] = isKam ? `${kamBaseStr}|feasibility|choose plan|need assistance` : `${customerBaseStr}|feasibility|choose plan|need assistance`;
    trackData['eVar9'] = isKam ? `${kamBaseStr}|feasibility|choose plan|need assistance|cancel` : `${customerBaseStr}|feasibility|choose plan|need assistance|cancel`;
  }

  if (leadStatus === LEAD_STATUS.LEAD_SUBMITTED) {
    trackData['eVar8'] = isKam ? `${kamBaseStr}|feasibility|choose plan` : `${customerBaseStr}|feasibility|choose plan`;
    trackData['eVar9'] = isKam ? `${kamBaseStr}|feasibility|choose plan|cancel` : `${customerBaseStr}|feasibility|choose plan|cancel`;
  }

  if (leadStatus === LEAD_STATUS.KYC_IN_PROGRESS) {
    trackData['eVar8'] = isKam ? `${kamBaseStr}|feasibility|choose plan|booking summary` : `${customerBaseStr}|feasibility|choose plan|booking summary`;
    trackData['eVar9'] = isKam ? `${kamBaseStr}|feasibility|choose plan|booking summary|cancel` : `${customerBaseStr}|feasibility|choose plan|booking summary|cancel`;
  }

  trackEvent(trackData);
};

const fsCancelPopupOnLoad = (leadData, userType) => {
  console.log('on cancel popup load', '--> click-stream');

  const { dataSet, leadStatus, isKam, customerBaseStr, kamBaseStr } = getBaseDataSet(leadData, userType);

  const trackData = {
    ...dataSet
  };

  if (leadStatus === LEAD_STATUS.LEAD_IN_PROGRESS) {
    trackData['eVar0'] = isKam ? `${kamBaseStr}|cancel` : `${customerBaseStr}|cancel`;
  }

  if (leadStatus === LEAD_STATUS.FEASIBILITY_COMPLETED) {
    trackData['eVar0'] = isKam ? `${kamBaseStr}|feasibility|cancel` : `${customerBaseStr}|feasibility|cancel`;
  }

  if (leadStatus === LEAD_STATUS.REQUIRED_PRICE_NEGOTIATION) {
    trackData['eVar0'] = isKam ? `${kamBaseStr}|feasibility|choose plan|need assistance|cancel` : `${customerBaseStr}|feasibility|choose plan|need assistance|cancel`;
  }

  if (leadStatus === LEAD_STATUS.LEAD_SUBMITTED) {
    trackData['eVar0'] = isKam ? `${kamBaseStr}|feasibility|choose plan|cancel` : `${customerBaseStr}|feasibility|choose plan|cancel`;
  }

  if (leadStatus === LEAD_STATUS.KYC_IN_PROGRESS) {
    trackData['eVar0'] = isKam ? `${kamBaseStr}|feasibility|choose plan|booking summary|cancel` : `${customerBaseStr}|feasibility|choose plan|booking summary|cancel`;
  }

  trackEvent(trackData);
};

const fsCancelPopupOnSubmit = (leadData, userType) => {
  console.log('on cancel popup submit button click', '--> click-stream');

  const { dataSet, leadStatus, isKam, customerBaseStr, kamBaseStr } = getBaseDataSet(leadData, userType);

  const trackData = {
    ...dataSet
  };

  if (leadStatus === LEAD_STATUS.LEAD_IN_PROGRESS) {
    trackData['eVar8'] = isKam ? `${kamBaseStr}|cancel` : `${customerBaseStr}|cancel`;
    trackData['eVar9'] = isKam ? `${kamBaseStr}|cancel|submit` : `${customerBaseStr}|cancel|submit`;
  }

  if (leadStatus === LEAD_STATUS.FEASIBILITY_COMPLETED) {
    trackData['eVar8'] = isKam ? `${kamBaseStr}|feasibility|cancel` : `${customerBaseStr}|feasibility|cancel`;
    trackData['eVar9'] = isKam ? `${kamBaseStr}|feasibility|cancel|submit` : `${customerBaseStr}|feasibility|cancel|submit`;
  }

  if (leadStatus === LEAD_STATUS.REQUIRED_PRICE_NEGOTIATION) {
    trackData['eVar8'] = isKam ? `${kamBaseStr}|feasibility|choose plan|need assistance|cancel` : `${customerBaseStr}|feasibility|choose plan|need assistance|cancel`;
    trackData['eVar9'] = isKam ? `${kamBaseStr}|feasibility|choose plan|need assistance|cancel|submit` : `${customerBaseStr}|feasibility|choose plan|need assistance|cancel|submit`;
  }

  if (leadStatus === LEAD_STATUS.LEAD_SUBMITTED) {
    trackData['eVar8'] = isKam ? `${kamBaseStr}|feasibility|choose plan|cancel` : `${customerBaseStr}|feasibility|choose plan|cancel`;
    trackData['eVar9'] = isKam ? `${kamBaseStr}|feasibility|choose plan|cancel|submit` : `${customerBaseStr}|feasibility|choose plan|cancel|submit`;
  }

  if (leadStatus === LEAD_STATUS.KYC_IN_PROGRESS) {
    trackData['eVar8'] = isKam ? `${kamBaseStr}|feasibility|choose plan|booking summary|cancel` : `${customerBaseStr}|feasibility|choose plan|booking summary|cancel`;
    trackData['eVar9'] = isKam ? `${kamBaseStr}|feasibility|choose plan|booking summary|cancel|submit` : `${customerBaseStr}|feasibility|choose plan|booking summary|cancel|submit`;
  }

  trackEvent(trackData);
};

const fsProceedBtnOnClick = (leadData, userType) => {
  console.log('on proceed button click', '--> click-stream');

  const { dataSet, leadStatus, isKam, customerBaseStr, kamBaseStr } = getBaseDataSet(leadData, userType);

  const trackData = {
    ...dataSet
  };

  if (leadStatus === LEAD_STATUS.LEAD_IN_PROGRESS) {
    trackData['eVar8'] = isKam ? `${kamBaseStr}` : `${customerBaseStr}`;
    trackData['eVar9'] = isKam ? `${kamBaseStr}|proceed` : `${customerBaseStr}|proceed`;
  }

  if (leadStatus === LEAD_STATUS.FEASIBILITY_COMPLETED) {
    trackData['eVar8'] = isKam ? `${kamBaseStr}|feasibility` : `${customerBaseStr}|feasibility`;
    trackData['eVar9'] = isKam ? `${kamBaseStr}|feasibility|proceed` : `${customerBaseStr}|feasibility|proceed`;
  }

  if (leadStatus === LEAD_STATUS.REQUIRED_PRICE_NEGOTIATION) {
    trackData['eVar8'] = isKam ? `${kamBaseStr}|feasibility|choose plan|need assistance` : `${customerBaseStr}|feasibility|choose plan|need assistance`;
    trackData['eVar9'] = isKam ? `${kamBaseStr}|feasibility|choose plan|need assistance|proceed` : `${customerBaseStr}|feasibility|choose plan|need assistance|proceed`;
  }

  if (leadStatus === LEAD_STATUS.LEAD_SUBMITTED) {
    trackData['eVar8'] = isKam ? `${kamBaseStr}|feasibility|choose plan` : `${customerBaseStr}|feasibility|choose plan`;
    trackData['eVar9'] = isKam ? `${kamBaseStr}|feasibility|choose plan|proceed` : `${customerBaseStr}|feasibility|choose plan|proceed`;
  }

  if (leadStatus === LEAD_STATUS.KYC_IN_PROGRESS) {
    trackData['eVar8'] = isKam ? `${kamBaseStr}|feasibility|choose plan|booking summary` : `${customerBaseStr}|feasibility|choose plan|booking summary`;
    trackData['eVar9'] = isKam ? `${kamBaseStr}|feasibility|choose plan|booking summary|proceed` : `${customerBaseStr}|feasibility|choose plan|booking summary|proceed`;
  }

  trackEvent(trackData);
};

const fsProceedPopupOnLoad = (leadData, userType) => {
  console.log('on proceed/(go back) popup load', '--> click-stream');

  const { dataSet, leadStatus, isKam, customerBaseStr, kamBaseStr } = getBaseDataSet(leadData, userType);

  const trackData = {
    ...dataSet
  };

  if (leadStatus === LEAD_STATUS.LEAD_IN_PROGRESS) {
    trackData['eVar0'] = isKam ? `${kamBaseStr}|proceed` : `${customerBaseStr}|proceed`;
  }

  if (leadStatus === LEAD_STATUS.FEASIBILITY_COMPLETED) {
    trackData['eVar0'] = isKam ? `${kamBaseStr}|feasibility|proceed` : `${customerBaseStr}|feasibility|proceed`;
  }

  if (leadStatus === LEAD_STATUS.REQUIRED_PRICE_NEGOTIATION) {
    trackData['eVar0'] = isKam ? `${kamBaseStr}|feasibility|choose plan|need assistance|proceed` : `${customerBaseStr}|feasibility|choose plan|need assistance|proceed`;
  }

  if (leadStatus === LEAD_STATUS.LEAD_SUBMITTED) {
    trackData['eVar0'] = isKam ? `${kamBaseStr}|feasibility|choose plan|proceed` : `${customerBaseStr}|feasibility|choose plan|proceed`;
  }

  if (leadStatus === LEAD_STATUS.KYC_IN_PROGRESS) {
    trackData['eVar0'] = isKam ? `${kamBaseStr}|feasibility|choose plan|booking summary|proceed` : `${customerBaseStr}|feasibility|choose plan|booking summary|proceed`;
  }

  trackEvent(trackData);
};

const fsProceedPopupOnSubmit = (leadData, userType) => {
  console.log('on proceed popup submit button click', '--> click-stream');

  const { dataSet, leadStatus, isKam, customerBaseStr, kamBaseStr } = getBaseDataSet(leadData, userType);

  const trackData = {
    ...dataSet
  };

  if (leadStatus === LEAD_STATUS.LEAD_IN_PROGRESS) {
    trackData['eVar8'] = isKam ? `${kamBaseStr}|proceed` : `${customerBaseStr}|proceed`;
    trackData['eVar9'] = isKam ? `${kamBaseStr}|proceed|ok` : `${customerBaseStr}|proceed|ok`;
  }

  if (leadStatus === LEAD_STATUS.FEASIBILITY_COMPLETED) {
    trackData['eVar8'] = isKam ? `${kamBaseStr}|feasibility|proceed` : `${customerBaseStr}|feasibility|proceed`;
    trackData['eVar9'] = isKam ? `${kamBaseStr}|feasibility|proceed|ok` : `${customerBaseStr}|feasibility|proceed|ok`;
  }

  if (leadStatus === LEAD_STATUS.REQUIRED_PRICE_NEGOTIATION) {
    trackData['eVar8'] = isKam ? `${kamBaseStr}|feasibility|choose plan|need assistance|proceed` : `${customerBaseStr}|feasibility|choose plan|need assistance|proceed`;
    trackData['eVar9'] = isKam ? `${kamBaseStr}|feasibility|choose plan|need assistance|proceed|ok` : `${customerBaseStr}|feasibility|choose plan|need assistance|proceed|ok`;
  }

  if (leadStatus === LEAD_STATUS.LEAD_SUBMITTED) {
    trackData['eVar8'] = isKam ? `${kamBaseStr}|feasibility|choose plan|proceed` : `${customerBaseStr}|feasibility|choose plan|proceed`;
    trackData['eVar9'] = isKam ? `${kamBaseStr}|feasibility|choose plan|proceed|ok` : `${customerBaseStr}|feasibility|choose plan|proceed|ok`;
  }

  if (leadStatus === LEAD_STATUS.KYC_IN_PROGRESS) {
    trackData['eVar8'] = isKam ? `${kamBaseStr}|feasibility|choose plan|booking summary|proceed` : `${customerBaseStr}|feasibility|choose plan|booking summary|proceed`;
    trackData['eVar9'] = isKam ? `${kamBaseStr}|feasibility|choose plan|booking summary|proceed|ok` : `${customerBaseStr}|feasibility|choose plan|booking summary|proceed|ok`;
  }

  trackEvent(trackData);
};

const fsThankYouOnLoad = (leadData, userType, showCancelPage = false) => {
  console.log('on thank you page load', '--> click-stream');

  const { dataSet, isKam, customerBaseStr, kamBaseStr } = getBaseDataSet(leadData, userType);

  let trackData = {
    ...dataSet,
    eVar0: isKam ? `${kamBaseStr}|feasibility|choose plan|booking summary|thank you` : `${customerBaseStr}|feasibility|choose plan|booking summary|thank you`
  };

  if (showCancelPage) {
    trackData.eVar0 = isKam ? `${kamBaseStr}|cancel|thank you` : `${customerBaseStr}|cancel|thank you`;
  }

  trackEvent(trackData);
};

const fsNeedAssistanceOnClick = (leadData, userType) => {
  console.log('on need assistance button click', '--> click-stream');

  const { dataSet, isKam, customerBaseStr, kamBaseStr } = getBaseDataSet(leadData, userType);

  const trackData = {
    ...dataSet,
    eVar8: isKam ? `${kamBaseStr}|feasibility|choose plan` : `${customerBaseStr}|feasibility|choose plan`,
    eVar9: isKam ? `${kamBaseStr}|feasibility|choose plan|need assistance` : `${customerBaseStr}|feasibility|choose plan|need assistance`
  };

  trackEvent(trackData);
};

const fsNeedAssistancePopupOnLoad = (leadData, userType) => {
  console.log('on need assistance popup load', '--> click-stream');

  const { dataSet, isKam, customerBaseStr, kamBaseStr } = getBaseDataSet(leadData, userType);

  const trackData = {
    ...dataSet,
    eVar0: isKam ? `${kamBaseStr}|feasibility|choose plan|need assistance` : `${customerBaseStr}|feasibility|choose plan|need assistance`
  };

  trackEvent(trackData);
};

const fsNeedAssistancePopupOnSubmit = (leadData, userType, reasonForNeedAssistance) => {
  console.log('on need assistance popup submit button click', '--> click-stream');

  const { dataSet, isKam, customerBaseStr, kamBaseStr } = getBaseDataSet(leadData, userType);

  const trackData = {
    ...dataSet,
    eVar8: isKam ? `${kamBaseStr}|feasibility|choose plan|need assistance` : `${customerBaseStr}|feasibility|choose plan|need assistance`,
    eVar9: isKam ? `${kamBaseStr}|feasibility|choose plan|need assistance|submit` : `${customerBaseStr}|feasibility|choose plan|need assistance|submit`,
    eVar25: reasonForNeedAssistance
  };

  trackEvent(trackData);
};

export {
  fsPageOnLoad,
  fsGoBackOnClick,
  fsCancelOrderOnClick,
  fsCancelPopupOnLoad,
  fsCancelPopupOnSubmit,
  fsProceedBtnOnClick,
  fsProceedPopupOnLoad,
  fsProceedPopupOnSubmit,
  fsThankYouOnLoad,
  fsNeedAssistanceOnClick,
  fsNeedAssistancePopupOnLoad,
  fsNeedAssistancePopupOnSubmit
};
